import ToastComponent from "./src/Toast.vue"; //引入toast.vue组件

export default {
  install: function (Vue) {
    const ToastConstructor = Vue.extend(ToastComponent); // 将toast.vue组件生成为Vue的子类
    const instance = new ToastConstructor(); // 生成一个该子类的实例

    instance.$mount(document.createElement("div")); // 将这个实例挂载在新创建的div上，并加入到body中
    document.body.appendChild(instance.$el);

    const show = (msg, type, duration) => {
      if (instance.visible) return; // visible是toast.vue组件的一个变量，用来控制提示框的显示
      instance.type = type;
      instance.message = msg;
      instance.visible = true;
      setTimeout(() => {
        // 默认延时1.5s关闭提示框
        instance.visible = false;
      }, duration);
    };
    Vue.prototype.$tip = {
      success: (msg, duration = 1500) => {
        show(msg, "success", duration);
      },
      info: (msg, duration = 1500) => {
        show(msg, "info", duration);
      },
      danger: (msg, duration = 1500) => {
        show(msg, "danger", duration);
      },
      warning: (msg, duration = 1500) => {
        show(msg, "warning", duration);
      },
    };
  },
};
